import { QuotesType } from "@/common/types";
import { singleQuoteSchema } from "@/common/types/schemas";
import { z } from "zod";

const generateQuoteReqDTO = (
  productType: QuotesType,
  generalData: any,
  pickedAddress: any,
  userId: number,
  date: { RFSdate: string; dueDate: string },
  isTouchedA: boolean,
  isTouchedB: boolean
) => {
  const { RFSdate, dueDate } = date;
  const data =
    productType === "EPL" || productType === "DWDM"
      ? {
          customerProjectNumber: generalData.projectName,
          endCustomerName: generalData.customerName,
          productType: productType,
          addressBValid: !isTouchedB,
          addressAValid: !isTouchedA,
          startAddress: {
            lat: pickedAddress?.pickedAAddress?.position.lat,
            long: pickedAddress?.pickedAAddress?.position.lng,
            city: pickedAddress?.pickedAAddress?.city,
            state: pickedAddress?.pickedAAddress?.state,
            street: pickedAddress?.pickedAAddress?.streetName,
            country: pickedAddress?.pickedAAddress?.country,
            buildingNumber: pickedAddress?.pickedAAddress?.streetNumber,
            zipCode: pickedAddress?.pickedAAddress?.postalCode,
          },
          endAddress: {
            lat: pickedAddress?.pickedBAddress?.position.lat,
            long: pickedAddress?.pickedBAddress?.position.lng,
            city: pickedAddress?.pickedBAddress?.city,
            state: pickedAddress?.pickedBAddress?.state,
            street: pickedAddress?.pickedBAddress?.streetName,
            country: pickedAddress?.pickedBAddress?.country,
            buildingNumber: pickedAddress?.pickedBAddress?.streetNumber,
            zipCode: pickedAddress?.pickedAAddress?.postalCode,
          },
          companyId: generalData.companyId,
          userId: userId,
          RFSdate,
          dueDate,
        }
      : {
          customerProjectNumber: generalData.projectName,
          endCustomerName: generalData.customerName,
          productType: productType,
          startAddress: {
            lat: pickedAddress?.pickedAAddress?.position.lat,
            long: pickedAddress?.pickedAAddress?.position.lng,
            city: pickedAddress?.pickedAAddress?.city,
            state: pickedAddress?.pickedAAddress?.state,
            street: pickedAddress?.pickedAAddress?.streetName,
            country: pickedAddress?.pickedAAddress?.country,
            buildingNumber: pickedAddress?.pickedAAddress?.streetNumber,
            zipCode: pickedAddress?.pickedAAddress?.postalCode,
          },
          companyId: generalData.companyId,
          userId: userId,
          RFSdate,
          dueDate,
          addressBValid: !isTouchedB,
          addressAValid: !isTouchedA,
        };
  try {
    const validatedValue = singleQuoteSchema.parse(data);
    return { withErrors: false, data: validatedValue };
  } catch (error) {
    if (error instanceof z.ZodError) {
      const errorsData = error.issues.reduce(
        (acc, issue) => {
          const path = issue.path.join(".");
          const message = issue.message;
          acc[path] = message;
          return acc;
        },
        {} as Record<string, string>
      );
      return { withErrors: true, data: errorsData };
    } else {
      console.error("Unexpected error:", error);
    }
  }
};
export default generateQuoteReqDTO;
